import React from 'react';
import c from 'classnames';

import {
  WysiwygField,
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import ExplainerSlider from './Slider';
import ExplainerStatic from './Static';

import './style.scss';

const ParagraphExplainerSlider = ({ entity }) => {
  // showAsSlider defaults to true to display as slider
  const showAsSlider = entity.getIn(['field_show_as_slider', 0, 'value'], true);

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], ''));
  const displayFullWidth = entity.getIn(['field_full_width', 0, 'value'], false);

  // Slider items
  const entities = entity.get('field_paragraphs', '');

  const colClasses = c('col-12', {
    'col-lg-8 offset-lg-2': !displayFullWidth || showAsSlider,
  });

  return (
    <Container className="Paragraph ParagraphExplainerSlider">
      <div className="row">
        <div className={colClasses}>
          <div className="ParagraphExplainerSlider__wrapper">
            <h2 className="ParagraphExplainerSlider__title">{title}</h2>

            <div className="ParagraphExplainerSlider__body">
              <WysiwygField html={body} />
            </div>

            {showAsSlider && (
              <ExplainerSlider items={entities} />
            )}

            {!showAsSlider && (
              <ExplainerStatic items={entities} isFullWidth={displayFullWidth} />
            )}

            {linkUrl && (
              <Button
                className="ParagraphExplainerSlider__button Button--ghost Button--primary"
                href={linkUrl}
              >
                {linkTitle}
                <i className="icon icon-arrow-right" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphExplainerSlider;
